import { JsonObject, JsonProperty } from 'json2typescript';
import { NumberOfDayOfWeekConverter} from 'app/models/numberOfDayOfWeekConverter';
import { DateConverter } from 'app/shared/json-converters/date-converter';
import { ShortDateConverter } from 'app/shared/json-converters/short-date-converter';
import * as moment from 'moment';
import { ClosedDatesArrayConverter } from 'app/shared/json-converters/closed-dates-array-converter';

/**
 * Model class representing a Project.
 */
@JsonObject
export class Visit {
   @JsonProperty('id')
   id: number = undefined;

   @JsonProperty('callerId')
   callerId: number = undefined;

   @JsonProperty('callpointId')
   callpointId: number = undefined;

   @JsonProperty('callpointReference')
   callpointReference: string = undefined;

   @JsonProperty('callpointDescription')
   callpointDescription: string = undefined;

   @JsonProperty('callpointDuration')
   callpointDuration: number = undefined;

   @JsonProperty('callpointIsDisabled')
   callpointIsDisabled: boolean = undefined;

   @JsonProperty('address')
   address: string = undefined;

   @JsonProperty('geocode')
   geocode: string = undefined;

   @JsonProperty('date', DateConverter, true)
   date: Date = undefined;

   @JsonProperty('date', ShortDateConverter, true)
   shortDate: string = undefined; // needed to implement sorting within the DataTable component

   @JsonProperty('startTime')
   startTime: string = undefined;

   @JsonProperty('dayOfWeek')
   dayOfWeek: string = undefined;

   @JsonProperty('scheduleWeek')
   scheduleWeek: number = undefined;

   @JsonProperty('isScheduled')
   isScheduled: boolean = undefined;

   @JsonProperty('isPartScheduled')
   isPartScheduled: boolean = undefined;

   @JsonProperty('dayOfWeek', NumberOfDayOfWeekConverter, true)
   numberOfDayOfWeek: number = undefined;

   @JsonProperty('frequency')
   frequency: number = undefined;

   @JsonProperty('lockType')
   lockType: string = undefined;

   @JsonProperty('sequenceInDay')
   sequenceInDay: number = undefined;

   @JsonProperty('driveTimeToCaller')
   public driveTimeToCaller: number = undefined;

   @JsonProperty('critical')
   public critical: string = undefined;

   @JsonProperty('priority')
   public priority: number = undefined;

   @JsonProperty('datesClosed', ClosedDatesArrayConverter, true)
   public datesClosed: string[] = undefined;

   @JsonProperty('startDay')
   public startDay: number = undefined;

   @JsonProperty('endDay')
   public endDay: number = undefined;

   @JsonProperty('startBreak')
   public startBreak: number = undefined;

   @JsonProperty('endBreak')
   public endBreak: number = undefined;

   @JsonProperty('startDate', DateConverter, true)
   startDate: Date = undefined;

   @JsonProperty('endDate', DateConverter, true)
   endDate: Date = undefined;
   
   @JsonProperty('salesValue')
   public salesValue: number = undefined;

   @JsonProperty('grade')
   public grade: number = undefined;

   @JsonProperty('address1')
   public address1: string = undefined;

   @JsonProperty('address2')
   public address2: string = undefined;

   @JsonProperty('address3')
   public address3: string = undefined;

   @JsonProperty('address4')
   public address4: string = undefined;

   @JsonProperty('address5')
   public address5: string = undefined;

   @JsonProperty('outOfPhase')
   public outOfPhase: number = undefined;

   //Not JSON mapped
   order: number = undefined;
   referenceAndOrder = undefined; // needed to implement sorting within the DataTable component
 
   private _driveTimeToCallerHms: string;
   public get driveTimeToCallerHms(): string {
      if (this._driveTimeToCallerHms === undefined) {
         let duration = <any>moment.duration(this.driveTimeToCaller, 'seconds');
         this._driveTimeToCallerHms = duration.format('HH:mm', {
            trim: false,
            forceLength: true
         });
      }
      return this._driveTimeToCallerHms;
   }

   public get daysOutOfPhase(): string{
      return `${this.outOfPhase} days`;
   }
}
